import React from 'react';
import styles from './styles.css';

const English = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <ol type="I">
        <p>
          <b>Kredivo Merchant Agreement (“Service/ Services”)</b>
        </p>
        <p>
          The below stated rules and undertakings apply to entities and
          individuals (collectively referred to as “<b>Merchant/Merchants</b>”)
          who have signed up for using Kredivo Checkout (a product of PT
          FinAccel Teknologi Indonesia) either directly with Kredivo or
          indirectly through a third party (e.g. the Merchant’s platform
          provider, the “<b>Partner</b>”) for their sales in Indonesia. The
          usage of Kredivo Checkout, and thus prior acceptance of these rules
          (including its General Terms and Conditions (the “<b>GTC</b>”))
          creates a direct contractual relation (together with any terms agreed
          upon with Kredivo or with the Partner on behalf of Kredivo, the “
          <b>Agreement</b>”) between each Merchant and Kredivo (jointly referred
          to as “<b>the Parties</b>”).
        </p>
        <ol type="1">
          <li>
            <b>Background and scope of the cooperation</b>
            <p>
              PT FinAccel Teknologi Indonesia (“<b>Kredivo</b>”) is a company
              supplying payment methods to Merchants selling online, offline and
              through other agreed sales channels. Kredivo Checkout is Kredivo ́s
              delayed and installment checkout solution for online and offline
              merchants (“<b>Kredivo Checkout</b>”). The Merchant operates an
              E-store(s) from the approved and agreed upon web
              addresses/URLs/Android app store (the “<b>E- store</b>”) or a
              retail chain which is registered under the rules and regulations
              of the specific country of operations (the “Retail Chain”). The
              Merchant can integrate Kredivo Checkout into its E-store, Retail
              Chain or any other purchase channels that may have been agreed
              between the Parties and thereby enable the Merchants customers to
              pay via Kredivo Checkout. Such integration may be done by the
              Merchant itself or through the use of a thirdparty.
            </p>
            <p>
              The Parties hereby agree to include Kredivo Checkout into the
              E-store, Retail Chain or any other agreed purchase channels for
              the countries specified through the agreement between the Merchant
              and the Partner making the Service available to the Merchant or
              regulated directly between the Merchant and Kredivo, and commit to
              cooperate in order to prepare and provide the Services.
            </p>
          </li>
          <li>
            <b>Purchase via Kredivo Checkout</b>
            <p>
              The purchase by a customer via Kredivo Checkout is conducted as
              follows: A customer who intends to buy now and pay later in
              connection with a purchase in the E-store or through other agreed
              purchase channels enters Kredivo Checkout after choosing which
              goods or services to purchase. If the customer is not an approved
              Kredivo user yet, he needs to download the Kredivo app or signup
              through the web interface and go through the application process.
              If the customer is an approved Kredivo user, the customer logs in
              to his account. Based on this information, Kredivo Checkout
              assesses whether sufficient credit limit is available to the
              customer to proceed with the purchase. After finalization of this
              assessment: if yes, the customer checks out and agrees to pay back
              Kredivo within 30 days (no installment) or longer (with
              installment); if no: the customer is told that the checkout via
              Kredivo cannot be completed and that he must use an alternate
              payment method (such customer is hereinafter referred to as a “
              <b>Customer</b>”).
            </p>
          </li>
          <li>
            <b>Acquisition of claims by Kredivo</b>
            <p>
              Upon finalization of the purchase by the Customer a reservation
              for the respective amount is made in Kredivo’s business
              transaction system (“<b>Kredivo ́s Order Tracking System</b>”) to
              which Kredivo grants theMerchant, or the Partner (on behalf of the
              Merchant) access in order to provide the Services. Kredivo
              undertakes to acquire the Merchant’s claim against the Customer
              (referred to as the “<b>Claim</b>”) subject to the terms and
              conditions set out in this Agreement. Kredivo acquires the Claim
              at the same time as when the transaction to purchase is completed
              between the Merchant and Customer (“<b>Activation</b>”). Upon
              acquisition of the Claim, Kredivo pays to the Merchant a
              settlement in accordance with what is set out below. The
              relationship between Kredivo and the Customer is regulated by an
              agreement between Kredivo and the Customer.
            </p>
          </li>
          <li>
            <b>Payments and Transaction Charges</b>
            <p>
              Kredivo pays to the Merchant, after deduction of Transaction
              Charges (as defined below) and other claims Kredivo may charge
              under this Agreement, the amount of the acquired Claims. Payments
              are made to the bank account provided by the Merchant for the
              respective country. Each Party bears its own bank transfer costs
              (if any). For providing its Services, Kredivo is entitled to
              charge the prices and fees agreed upon between the Parties in
              relation to the respective country (the “
              <b>Transaction Charges</b>“). Any Transaction Charges and other
              claims Kredivo may have under this Agreement are quoted excluding
              Sales Tax or Service Tax or Value Added Tax, wherever such tax is
              applied. In such a case the Merchant changes partner, Kredivo
              reserves the right to charge Transaction Charges according to what
              has been agreed between the Merchant and this new partner or
              according to Kredivo’s standard pricing (which may deviate
              dependent upon segment, volume, Merchant financials etc).
            </p>
          </li>
          <li>
            <b>Specific conditions for Kredivo Checkout</b>
            <p>
              The rights and obligations of the Parties are set out in detail in
              the GTC, which are stated below and also provided to the Merchant
              on request.
            </p>
          </li>
          <li>
            <b>Agreement period</b>
            <p>
              Unless otherwise agreed (any previous effective agreement between
              the Parties in relation to Kredivo Checkout takes precedence), the
              Agreement will be valid from the date of the Merchant’s first
              usage of the Services under this Agreement and remains valid until
              terminated by either Party, giving one (1) months’ notice.
              Notwithstanding the foregoing, Kredivo reserves the right to, at
              any time, without prior warning cancel the Merchant’s Agreement
              with Kredivo and stop delivering the Services in case of a breach
              of GTC.
            </p>
          </li>
        </ol>
        <p>
          <b>General Terms & Conditions</b>
        </p>
        <p>
          The general terms and conditions set out below are referred to as the
          “<b>GTC</b>”. Definitions and expressions used in the main part shall,
          unless specifically stated otherwise, have the same meaning in the
          GTC.
        </p>
        <ol type="1">
          <li>
            <b>Kredivo’s General Responsibilities</b>
            <ol type="a">
              <li>
                Kredivo is responsible for all credit control, financing,
                administration and customer service in respect of the Services.
                In relation to acquired Claims, Kredivo will handle the
                collection and any administration. All of the above activities
                may be performed by Kredivo in partnership with a third party.
              </li>
              <li>
                Kredivo bears the credit risk and the fraud risk for the Claim,
                except for the cases listed in section 3. In cases where Kredivo
                bears the fraud risk, Kredivo will compensate the Merchant with
                the full amount of the Claim excluding taxes.
              </li>
              <li>
                Kredivo provides the terms and conditions and information to be
                disclosed by the Merchant regarding Kredivo ́s Services in
                relation to Customers before, in connection with and after the
                purchase (the “<b>Customer Terms and Conditions</b>”). Kredivo
                may, at its own discretion, change the Customer Terms and
                Conditions and any other Customer related material (such as
                contracts, forms or information regarding the Services). Kredivo
                ensures that Customer Terms and Conditions are in conformity
                with any applicable laws and regulations.
              </li>
              <li>
                Unless otherwise agreed, Kredivo will, after having received an
                electronic notification thereof from the Merchant about
                transaction success, send invoices to the Customers via either
                or a combination of E-mail, sms and in-app notification. In
                relation to Kredivo Checkout, invoicing and other payment
                related notices to the Customer will always be made by Kredivo.
                Regardless, Kredivo always decides in its own discretion on any
                information sent/ contained on the invoices and other payment
                related notices.
              </li>
            </ol>
          </li>
          <li>
            <b>Merchant’s General Responsibilities</b>
            <ol type="a">
              <li>
                The Merchant shall present and market the Services by displaying
                Kredivo ́s logotype. In relation to other marketing activities
                which include a reference to Kredivo or the Services, the
                Merchant shall coordinate such activities with Kredivo in
                advance by contacting Kredivo at marketing@kredivo.com. When
                marketing and using the Services, the Merchant will observe and
                abide to any applicable laws and regulations and other
                provisions and guidelines issued by any public authority.
              </li>
              <li>
                The Merchant undertakes to follow the instructions of Kredivo
                regarding the integration of the Services (e.g. in Kredivo’s
                integration guidelines which can be found under
                https://doc.Kredivo.com, the “Integration Guidelines”) and
                ensures that it at all times maintains the technical
                requirements needed on its part to enable the use of the
                Services.
              </li>
              <li>
                The Merchant shall provide Kredivo with information that Kredivo
                needs in order to provide the Services e.g. information needed
                by Kredivo in order to identify the Customer.
              </li>
              <li>
                The Merchant shall provide the Customer with the Customer Terms
                and Conditions and ensures that the Customer confirms that these
                are accepted. Details are described in the Integration
                Guidelines. Furthermore, the Merchant is obliged to display the
                address of its permanent establishment, its privacy policy in
                the E- Store and an active customer service E-mail address and a
                customer service telephone number in the E-Store.
              </li>
              <li>
                The Merchant is not entitled to use its own invoice forms in
                relation to Customers.
              </li>
              <li>
                The Merchant will be given access to daily transaction reports
                and/or Kredivo’s Order Tracking System. The Merchant is
                responsible for their unique log-in and any actions taken when
                the log-in details are used.
              </li>
            </ol>
          </li>
          <li>
            <b>Claim Returns</b>
            <p>
              Kredivo has the right to return Claims to the Merchant as per the
              following, and thereby also has the right to berefunded:
            </p>
            <ol type="a">
              <li>
                Claims where delivery of the goods or services has not been
                carried out at all, has been unreasonably delayed or has been
                carried out to an address other than one approved by Kredivo or
                specified by the Customer at the time of the respective
                purchase.
              </li>
              <li>
                If the Customer has a right to set off on account of
                counterclaim against the Merchant or a right to discounts or
                other deductions.
              </li>
              <li>
                If there is a dispute or contestation between the Merchant and
                the Customer regarding the Claim and such dispute or
                contestation is not based on a mere unwillingness or inability
                to pay. A dispute may be e.g. when the goods or services are
                alleged to be faulty or not delivered in full.
              </li>
              <li>
                Claims which relate to a natural or legal person who may
                reasonably be considered to share a financial interest with the
                Merchant, including, but not limited to, a company affiliated to
                the Merchant, owners or an employee of the Merchant and/or such
                affiliated company. This sub-section (d) merely applies if the
                Merchant has less than thirty (30) employees.
              </li>
              <li>
                Claims in relation to which a Customer acquires cash, checks or
                moneyorders from the Merchant.
              </li>
              <li>
                Claims where the Customer insists not having made the order or
                insists not having received the good, or if it is otherwise
                unclear who has received the goods/services.
              </li>
              <li>
                Claims where the Merchant does not meet the requirements under
                section 4 and 5 below, or where the Merchant in connection with
                invoicing, Activation or otherwise breaches the Agreement.
              </li>
              <li>
                Claims where the Customer has purchased a product not
                covered/approved under Kredivo’s checkout policies (digital
                download, firearms, drugs, pornography and anything else illegal
                under the local country’s laws).
              </li>
              <li>
                Claims in relation to which the Merchant is imposing terms and
                conditions in relation to Customers which deviate from the terms
                and conditions provided by Kredivo or if the Merchant has agreed
                terms with the Customer that deviate from what has been
                communicated with Kredivo
              </li>
            </ol>
          </li>
          <li>
            <b>Responsibilities of the Parties in relation toClaims</b>
            <ol type="a">
              <li>
                The Merchant may not without Kredivo’s written consent enter
                into an agreement or arrangement with any third party regarding
                the purchase, pledging or payment of Claims, nor any other
                arrangement which restricts the right to transfer the Claims.
                The Merchant may not conclude agreements with Customers in other
                countries than those contractually agreed or in other currencies
                than those that apply to the respective countries.
              </li>
              <li>
                If payment is made directly by the Customer or a third party to
                the Merchant, this shall immediately be communicated to Kredivo.
                The Merchant has to immediately transfer the amount to Kredivo
                and specify what the payment refers to. Alternatively, the
                Merchant’s debt to Kredivo may be settled against other Claims.
              </li>
              <li>
                After acquisition of a Claim by Kredivo, the Merchant has to
                inform Kredivo immediately if the Merchant has agreed with the
                Customer on a return of goods/service or a reduction of the
                purchase price, or if the Customer has used its
                return/revocation rights provided by law.
              </li>
              <li>
                The Merchant shall answer Kredivo’s questions regarding Claims
                without undue delay. The Parties shall in particular inform each
                other if a Customer disputes the obligation to settle the Claim.
                The Merchant undertakes to handle complaints promptly and
                correctly. The Merchant has to inform Kredivo if a complaint has
                not been solved within one (1) month afterreceipt.
              </li>
              <li>
                In relation to Kredivo Checkout, the Merchant is not entitled to
                impose any fees or otherwise a higher price for goods or
                services on the basis that the purchase is made through Kredivo
                Checkout, or, to act discriminatory towards Kredivo in any other
                way.
              </li>
              <li>
                The Merchant is responsible for the fulfillment of its
                obligations under its contractual relationship with the Customer
                and/or under any applicable law. The Merchant is not entitled to
                use the Services in relation to transactions which are deemed
                illegal under any applicable law or which violate Kredivo’s
                instructions.
              </li>
              <li>
                The Parties agree that together with the Claim also all
                securities related to the Claim shall be transferred to Kredivo,
                such as for example any retention of title in the goods
                delivered. In case of a retransfer of a Claim, any such
                transferred security will also be retransferred.
              </li>
            </ol>
          </li>
          <li>
            <p>
              Specific conditions concerning purchases and handout of goods in
              physical stores Unless the Merchant operates a Retail Chain at the
              time of signing of this Agreement, the Merchant is not entitled to
              use the Services for the sale of goods in physical stores. Goods
              purchased via the Services can be handed out to Customers in
              physical stores of the Merchant. If the Merchant has integrated
              Kredivo Checkout at its Retail Chain, then the Merchant is liable
              for damages (repair and replacement) of any physical hardwarde
              (for example, EDC device) that is supplied by Kredivo or a Kredivo
              affiliated vendor. The fee structure for repair and replacement is
              as follows: EDC Teminal replacement: Rp 4.500.000 Printer cover:
              Rp 200.000 Adaptor: Rp 350.000 Adaptor cable: Rp 250.000 LCD: Rp
              1.000.000 Keypad: Rp 200.000 Roller Printer: Rp 350.000 Service
              fees for each repair: Rp 150.000 Kredivo may update these fees
              from time to time.
            </p>
          </li>
          <li>
            <b>Credit limit</b>
            <p>
              Kredivo will at its own discretion set a credit limit for each
              Customer. Kredivo reserves the right to change such credit limit
              at anytime.
            </p>
          </li>
          <li>
            <b>Module Support</b>
            <p>
              Kredivo aims to support all modules and API’s that the Merchant
              uses to connect to Kredivo’s Order Tracking System. However, as
              technology progresses, Kredivo reserves the right to decide in its
              sole discretion which modules and API’s to support. If Kredivo at
              some point cancels support of a certain module or API, Kredivo
              will first provide a notice of three (3) months. Information on
              which modules and API’s Kredivo supports can be found at
              http://doc.kredivo.com.
            </p>
          </li>
          <li>
            <b>Duty to inform</b>
            <p>
              For, inter alia, anti-money laundering (“<b>AML</b>”) purposes,
              the Merchant shall immediately inform Kredivo:
            </p>
            <ol type="a">
              <li>
                regarding circumstances concerning the Merchant and its owner,
                which may be of significant importance for assessment of the
                Merchant’s financial status;
              </li>
              <li>
                about changes relating to the Merchants address, its management,
                its board or AML relevant changes to the ownership structure;
              </li>
              <li>
                if there are any material changes with regard to the type of
                products or services offered by the Merchant or if the name
                under which the Merchant conducts its business is changed; or
              </li>
              <li>
                if there are any other material changes relating to the Merchant
                or its activities.
              </li>
            </ol>
          </li>
          <li>
            <b>Termination</b>
            <p>
              Each Party has the right to terminate the Agreement with immediate
              effect if:{' '}
            </p>
            <ol type="a">
              <li>
                the other Party materially breaches any provision of the
                Agreement; the other Party repeatedly or continuously fails to
                meet its obligations under the Agreement and does not upon the
                other Party’s request remedy such failure within the time frame
                given by such other Party;
              </li>
              <li>
                the other Party has provided incorrect or misleading
                information, or has concealed circumstances of importance; or
              </li>
              <li>
                the other Party’s financial situation is significantly
                deteriorated.
              </li>
              <p>
                In addition, Kredivo has the right to terminate the Agreement
                if:
              </p>
              <li>
                the Merchant offers services or goods that violate Kredivos from
                time to time applicable instructions; or
              </li>
              <li>
                Kredivo suspects a breach of the Agreement, and the Merchant
                does not, without undue delay, provide such reasonably requested
                information that is of importance in order to determine whether
                the Merchant has breached the Agreement.
              </li>
            </ol>
            <p>
              In case Kredivo terminates this Agreement under this section 9,
              Kredivo has the right to, after deduction of the Transaction
              Charges or any other charges which Kredivo is entitled to claim
              under the Agreement, return to the Merchant all unsettled Claims
              that have been acquired and to claim a refund.
            </p>
            <p>
              The Merchant is aware and accepts that the payment term included
              in Kredivo Checkout may change from time to time and that Kredivo
              may remove any single payment term option at any point in time.
            </p>
          </li>
          <li>
            <b>Right to retain payments/ Set-off</b>
            <ol type="a">
              <li>
                In the event of termination by one of the Parties, Kredivo
                reserves the right to retain further payments to the Merchant
                and instead undertake a final account and payout after Kredivo
                has checked the status of the outstanding Claims and the
                deadline for returns has passed.
              </li>
              <li>
                Kredivo may temporarily retain payments corresponding to the
                amount of damages/increased risks which might be incurred by
                Kredivo if the Merchant materially or, after a warning,
                repeatedly fails to meet its obligations. The same applies if
                the Merchant’s sales through Kredivo show a significantly
                elevated level of returns or complaints in comparison to the
                Merchant’s historic figures. Prior to withholding funds in
                accordance with this sub-section (b), Kredivo undertakes to
                inform the Merchant as to the reason why funds will be withheld.
              </li>
              <li>
                Kredivo may temporarily retain payments corresponding to the
                amount of damages/ increased risks if Kredivo reasonably
                suspects that the Merchant’s financial situation has
                deteriorated significantly. Kredivo may retain such payments
                until the Parties have agreed on a solution to mitigate the risk
                or until the Merchant has provided adequate proof of a sound
                financial situation. In connection with withholding funds in
                accordance with this sub-section (c) Kredivo undertakes to
                inform the Merchant as to the reason why funds will be withheld.
              </li>
              <li>
                Kredivo may, in its own discretion, offset any amounts owed to
                the Merchant against any claims Kredivo may have against the
                Merchant.
              </li>
            </ol>
          </li>
          <li>
            <b>Force majeure</b>
            <p>
              If the Parties are prevented from fulfilling their obligations
              under this Agreement due to circumstances which the Parties have
              no control over - e.g. lightning strike, fire, changed legal
              provisions or regulations provided by authorities, intervention by
              authorities, strike, communication or transport disruptions,
              changes in exchange rates or natural disasters - the Parties shall
              be released from its liabilities until the circumstance given rise
              to the Parties’ inability to fulfill their respective obligations
              no longer exists. This section 11 shall be viewed in the light of
              Kredivo having a redundant system with geographically dispersed
              server sites. If a Party is prevented to fulfill its obligation
              for a longer period than 30 days due to any such circumstance
              mentioned above, the Parties shall have the right, without being
              liable to pay compensation, to terminate the Agreement with
              immediate effect.
            </p>
          </li>
          <li>
            <b>Liability</b>
            <p>
              If a Party does not fulfill its obligations under this Agreement,
              the other Party shall be entitled to claim damages. Each Party’s
              annual liability to pay any compensation or similar under this
              Agreement is limited to the greater of (i) an amount corresponding
              to the Transaction Charges paid or payable by the Merchant to
              Kredivo in the twelve (12) months immediately preceding any claim
              or (ii) USD 5,000. Neither Party is liable for unforeseeable
              damages or damages atypical for the Agreement, and particularly
              not for indirect or consequential damages.{' '}
            </p>
            <p>
              Notwithstanding the above, the Merchant has to fully indemnify
              Kredivo from and against any losses, claims or damages (including,
              but not limited to, fines and penalties) arising out of the
              failure to fulfill its information obligations in relation to the
              Customers. Additionally, the Merchant’s liability in relation to
              any amounts or claims relating to a return of a Claim under
              section section 3 or 9 shall not be subject to the above stated
              limitation ofliability.
            </p>
          </li>
          <li>
            <b>Communication</b>
            <p>
              Notice of termination or any other correspondence under this
              Agreement shall be made in writing by letter or E-mail to the
              contact details provided in the Main Agreement or as agreed
              otherwise in writing. E-mails to Kredivo shall be sent to the
              following E-mail address: merchops@kredivo.com.
            </p>
          </li>
          <li>
            <b>Amendments to the Agreement</b>
            <p>
              Kredivo is entitled to unilaterally change any conditions of this
              Agreement, provided that Kredivo notifies the Merchant of the
              changes at least 30 days in advance. In such cases, the Merchant
              is entitled to terminate the Agreement with a 30 days’ notice
              period. Such notice of termination shall be issued not later than
              60 days after the Merchant receives the notification ofamendment.
            </p>
          </li>
          <li>
            <b>Transfers</b>
            <p>
              Neither Party may transfer its rights and obligations under the
              Agreement without the other Party’s prior written consent.
              Notwithstanding the foregoing, Kredivo has the right to transfer,
              pledge or in any other way dispose over the Claims without the
              Merchant’s consent. Kredivo is entitled to engage subcontractors
              in order to provide its Services.
            </p>
          </li>
          <li>
            <b>Confidentiality</b>
            <p>
              The Parties undertake, during the term of this Agreement and for a
              period of two (2) years thereafter, not to disclose Confidential
              Information to any third party without the other Party’s written
              consent. "Confidential Information" means any information, in
              whatever form, disclosed or provided by one Party to the other
              party (the “<b>Receiving Party</b>”) in the context of this
              Agreement. Non-confidential information means any information
              which (a) is or becomes generally available to the public other
              than as the result of a disclosure by the Receiving Party; (b) the
              Receiving Party can show that it already had in its possession
              before it was received; (c) information which the Receiving Party
              is obliged to provide in accordance with any applicable laws,
              court order or decision by a governmental authority; or (d)
              information which the Receiving Party has received from a third
              party without being bound by confidentiality in relation to it.
              For the avoidance of doubt, Confidential Information also refers
              to third party information of technical, commercial or other
              nature unless there are objective and reasonable grounds to assume
              that such information is non- confidential. This provision applies
              to any information relating to third parties that the Merchant
              obtains when using Kredivo’s Order Tracking System or when
              communicating with Kredivo, and where it is clear that the
              dissemination of the abovementioned information is not desired by
              third parties.
            </p>
          </li>
          <li>
            <b>Data protection – Controller of PersonalData</b>
            <ol type="a">
              <li>
                <b>Handling of Customer data</b>
              </li>
              <p>
                The Parties agree and acknowledge that they will both be
                independently acting as data controllers in respect of personal
                data processed by them respectively pursuant to the Agreement,
                and that Kredivo will be data controller in respect of any data
                received by it from Customers. Both Parties agree to comply with
                applicable privacy laws in respect of personal data processed
                pursuant to the Agreement. If, and to the extent that, a Party
                processes personal data on behalf of the other, the Parties
                shall in good faith discuss and agree upon a separate data
                processingagreement.
              </p>
              <li>
                <b>Handling of Merchant contact data</b>
              </li>
              <p>
                Kredivo will electronically process personal data pertaining to
                the contact persons of the Merchant, such as contact
                information, in order to provide the Merchant with the Services
                and to administer the business relationship with the Merchant.
                The data may also be used for statistical analysis and business
                reporting purposes, during fraud investigations and to comply
                with applicable laws and regulations. Kredivo is committed to
                protecting personal data and will put in place adequate
                safeguards in order to protect the data.
              </p>
              <li>
                <b>Handling of Merchant contact data for marketing purposes</b>
              </li>
              <p>
                Kredivo may use Merchant contact data in order to send
                Newsletters, to conduct product surveys, to advertise similar
                products or services of Kredivo and for event invitations. BY
                PROVIDING PERSONAL DATA ABOUT OTHER PERSONS THE MERCHANT
                CONFIRMS THAT IT HAS CONSENT TO DISCLOSE SUCH DATA AND FOR THE
                DATA TO BE USED FOR THE PURPOSES AND IN THE WAYS DESCRIBED IN
                (b) AND (c).
              </p>
            </ol>
          </li>
          <li>
            <b>IP rights and know-how</b>
            <p>
              Kredivo retains all ownership and intellectual property rights to
              anything developed by Kredivo and provided to or accessed by the
              Merchant under the Agreement. After termination of the Agreement,
              the Merchant undertakes to immediately remove all respective
              logotypes and similar of Kredivo. Kredivo is entitled to refer to
              the Merchant as user of the Services in marketing, sales or
              similar material.
            </p>
          </li>
          <li>
            <b>Governing law and jurisdiction</b>
            <p>
              This Agreement is governed by the laws of Indonesia. Any dispute
              or controversy under or relating to this Agreement shall be
              settled by the courts of Indonesia with South Jakarta as first
              instance.
            </p>
          </li>
          <li>
            <b>Severability clause</b>
            <p>
              Should a provision of this Agreement become invalid or
              unenforceable, this will not affect the other provisions and the
              validity of this Agreement. Instead of the invalid or
              unenforceable provision, the Parties shall decide on a wording
              that comes as close as possible to the commercial meaning and
              purpose of such provision.
            </p>
          </li>
        </ol>
      </ol>
    </div>
  );
};

export default English;
